import {Animated, Dimensions, Pressable, ScrollView} from "react-native"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, View} from "shared/base"
import React, {useEffect, useMemo, useRef} from "react"
import {Course} from "models"
import CourseCard from "./course-card"
import {digg} from "diggerize"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import useEventListener from "@kaspernj/api-maker/build/use-event-listener"

const courseContainerWidth = 252
const courseContainerWidthWithMargin = courseContainerWidth + 24

export default memo(shapeComponent(class RoutesUserSchoolClassesClassSpaceCourses extends ShapeComponent {
  static propTypes = propTypesExact({
    activeCourse: PropTypes.instanceOf(Course).isRequired,
    courseBackgrounds: PropTypes.object.isRequired,
    courses: PropTypes.array.isRequired,
    onCourseChange: PropTypes.func.isRequired
  })

  windowWidth = new Animated.Value(Dimensions.get("window").width)

  setup() {
    const {activeCourse} = this.p
    const coursesContainerRef = useRef()

    this.setInstance({coursesContainerRef})

    useMemo(() => {
      if (coursesContainerRef.current) {
        coursesContainerRef.current.scrollTo({x: this.getScrollTo(), animated: true})
      }
    }, [activeCourse, coursesContainerRef.current])

    // Scroll to the initial position after render.
    useEffect(() => {
      coursesContainerRef.current.scrollTo({x: this.getScrollTo(), animated: true})
    }, [])

    useEventListener(Dimensions, "change", this.tt.onDimensionsChange)
  }

  getScrollTo() {
    const {activeCourse, courses} = this.p
    const coursePosition = courses.indexOf(activeCourse) + 1
    const scrollTo = (coursePosition * courseContainerWidthWithMargin) - courseContainerWidthWithMargin

    return scrollTo
  }

  render() {
    const {activeCourse, courseBackgrounds, courses} = this.p

    return (
      <View dataSet={this.rootViewDataSet ||= {testid: "courses-root-view"}} style={{border: 0}}>
        <ScrollView
          dataSet={this.scrollViewDataSet ||= {testid: "courses-scroll-view"}}
          horizontal
          ref={this.tt.coursesContainerRef}
          scrollEnabled={false}
          showsHorizontalScrollIndicator={false}
          style={{border: 0}}
        >
          <Animated.View
            dataSet={this.scrollViewInsideViewDataSet ||= {testid: "courses-animated-view-inside-scroll-view"}}
            style={this.scrollViewInsideViewStyle ||= {
              border: 0,
              flexDirection: "row",
              alignItems: "end",
              minHeight: 430,
              marginLeft: 50,
              marginRight: this.tt.windowWidth
            }}
          >
            {courses?.map((course, courseIndex) =>
              <View key={course.id()} style={{marginRight: (courseIndex + 1) < courses.length ? 24 : undefined}}>
                <CourseCard
                  active={course == activeCourse}
                  backgroundImage={digg(courseBackgrounds, course.id())}
                  course={course}
                  onPress={this.tt.onCoursePress}
                />
              </View>
            )}
          </Animated.View>
        </ScrollView>
        <View
          style={this.actionsContainerStyle ||= {
            position: "absolute",
            top: 29,
            right: 128,
            flexDirection: "row"
          }}
        >
          <Pressable
            onPress={this.tt.onNavigatePreviousPress}
            style={this.navigatePreviousPressableStyle ||= {
              alignItems: "center",
              justifyContent: "center",
              width: 60,
              height: 60,
              border: "1px solid #fff",
              borderRadius: 24
            }}
          >
            <Icon color="#fff" name="chevron-left" size={24} />
          </Pressable>
          <Pressable
            onPress={this.tt.onNavigateNextPress}
            style={this.navigateNextPressableStyle ||= {
              alignItems: "center",
              justifyContent: "center",
              width: 60,
              height: 60,
              marginLeft: 12,
              border: "1px solid #fff",
              borderRadius: 24
            }}
          >
            <Icon color="#fff" name="chevron-right" size={24} />
          </Pressable>
        </View>
      </View>
    )
  }

  onCoursePress = ({course}) => this.setActiveCourse(course)

  onDimensionsChange = ({window}) => {
    this.windowWidth.setValue(window.width)
  }

  onNavigateNextPress = () => {
    const {activeCourse} = this.p
    const activeCoursePosition = this.p.courses.indexOf(activeCourse)
    const newActiveCourse = this.p.courses[activeCoursePosition + 1] || this.p.courses[0]

    if (newActiveCourse) {
      this.setActiveCourse(newActiveCourse)
    }
  }

  onNavigatePreviousPress = () => {
    const {activeCourse, courses} = this.p
    const activeCoursePosition = courses.indexOf(activeCourse)
    const newActiveCourse = courses[activeCoursePosition - 1] || courses[courses.length - 1]

    if (newActiveCourse) {
      this.setActiveCourse(newActiveCourse)
    }
  }

  setActiveCourse = (course) => this.p.onCourseChange({course})
}))
